import { Options, Vue } from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { Question } from '../question-model';
import RadioButtonHorizontal from '../radiobutton-horizontal/index.vue';
import store from '@/trust-atcs-app/store';
import Popover from '@/shared/components/popover/index.vue';
import { orderBy } from 'lodash';

@Options<MultiRadioBoxes>({
  components: {
    RadioButtonHorizontal,
    Popover
  }
})
export default class MultiRadioBoxes extends Vue {

  @Prop()
  private question!: any;
  private validSubQuestion: boolean[] = [];
  private newWording = '';
  private obj = null as any;

  created(): void {
    this.question.responses = orderBy(this.question.responses, 'order', 'asc'); 
    this.validSubQuestion = this.question.atcsSubQuestions.map((q: any) => false);
    const content = store.getters.getPopovers;
    const popovers = this.question.wording.match(/--{{([^)]+)}}--/)[1];
    this.obj = content.filter((x:any) => x.key == popovers)[0] ?? {};
    this.newWording = this.question.wording.replace('--{{' + popovers + '}}--', '');
    this.$emit('validForm', this.validForm());
  }

  private onValueChanged(event: any, i: any): void {
    this.$emit('changed', event);
    // this.$emit('validForm', this.validForm());
  }

  private validationForm(i: any, isValid: any) {
    this.validSubQuestion[i] = isValid;
    this.$emit('validForm', this.validForm());
  }

  private validForm(): boolean {
    return !this.validSubQuestion.includes(false);
  }

}
